import { render, staticRenderFns } from "./Page2.vue?vue&type=template&id=f4c7878e"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4c7878e')) {
      api.createRecord('f4c7878e', component.options)
    } else {
      api.reload('f4c7878e', component.options)
    }
    module.hot.accept("./Page2.vue?vue&type=template&id=f4c7878e", function () {
      api.rerender('f4c7878e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Page2.vue"
export default component.exports